/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const OrderDetailPage = lazyLoad(
  () => import('./index'),
  module => module.OrderDetailPage
);
